import { VisibilityState } from '@tanstack/vue-table'

import { importSchema, ZInferType } from '@/schemas'
import { ClinicType } from '@/types'

export enum ImportStatusEnum {
  PENDING = 'pending',
  READY = 'ready',
  PROCESSING = 'processing',
  QUEUED = 'queued',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export type ImportUpdateRecordType = {
  id: string
  status?: ImportStatusEnum
  mapped_data?: Record<string, string | null> | null
}

export type ImportUpdateType = {
  records: ImportUpdateRecordType[]
}

export type ImportFileType = {
  id: string
  import_batch_id?: string
  source: string
  type: string
  status: ImportStatusEnum
  original_filename: string
  file_path: string
  file_hash: string
  website: ClinicType
  created_at: string
  updated_at: string
}

export type ImportRecordType = {
  id: string
  import_file_id: string
  external_id: string
  internal_id: string | null
  status: ImportStatusEnum
  data: Record<string, string>
  mapped_data: Record<string, string | null> | null
}

export type ImportFileInfoType = {
  data: ImportFileType
  parent: ImportFileType | null
  children: ImportFileType[]
}

export type BaseFieldUpdateType = {
  id: string
  mapped_data: Record<string, string>
}

export type MappedFieldUpdateType = {
  field: string
  value: string
  records: string[]
  all: boolean
}

export type ImportFilterType = {
  type?: string
  columnVisibility?: VisibilityState
  columnOrder: string[]
}

export type ImportFormType = ZInferType<typeof importSchema>
